window.Dropbox = {

	enableAutoSync : function(me){

		var enabled = "N";
		if (me.is(':checked')){
			enabled = "Y";
		}

		MyFacture.post("dropbox_prefs", "do=toggleAutoSync&enabled="+enabled, function(response){});

	},

	enableMultiSync : function(me){

		var enabled = "N";
		if (me.is(':checked')){
			enabled = "Y";
		}

		MyFacture.post("dropbox_prefs", "do=toggleMultiSync&enabled="+enabled, function(response){});

	},

	connectToDropbox : function() {
		MyFacture.post("dropbox_prefs&action=connectToDropbox", null,  function(data) {
			if(data != null) {
				var options = {
					resizable	: false,
					noclose		: true,
					title		: Loc.g("Connexion à Dropbox"),
					buttons		: [
						{text : Loc.g("Valider"), click: function(){window.location = data.dropbox_authorise_url;}},
						{text : Loc.g("Annuler"), click: function(){MyFacture.post("dropbox_prefs&action=disconnectToDropbox", null, null, "json");$(this).dialog("close");}}
					]
				};
				MyWindow.alert(Loc.g("Vous allez être redirigé vers la page d'authentification de dropbox.")+"<br/><br /> "+Loc.g("Acceptez l'application pour synchroniser vos documents."), options);
			}
		}, "json");

		$(document).keyup(function(e) {
			if (e.keyCode == 27) {
				MyFacture.post("dropbox_prefs&action=disconnectToDropbox", null, null, "json");
			}
		});
	},

	confirmConnectToDropbox : function() {
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Connexion à Dropbox"),
			buttons		: [{
				text : "Valider",
				click : function(){ $(this).dialog("close");	}
			}]
		};
		MyWindow.alert(Loc.g("Vous êtes maintenant connecté à dropbox.")+"<br/><br/>"+Loc.g("Vous pouvez dès à présent synchroniser vos documents en vous rendant sur l'onglet")+" <a href='?_f=briefcase' style='color:blue;'>"+Loc.g("fichiers")+"</a>.", options);
	},

	disconnectToDropbox : function() {
		MyFacture.post("dropbox_prefs&action=disconnectToDropbox", null, function(data) {
			$('#status').text(data.status);
			$('#buttonDropbox').text("Me connecter");
			$('#buttonDropbox').attr('onclick', "Dropbox.connectToDropbox();");
			MyWindow.close();
			Dropbox.loadPrefs();
		}, "json");
	},

	loadPrefs : function(){
		var options = {
			title	: Loc.g("Préférences Dropbox"),
			buttons	: [
				{text : Loc.g("Fermer"), class: 'btn btn-default', click : function(){MyWindow.close();}}
			],
			width: 500
		};

		var fileOpt = {action:""};
		MyWindow.load("dropbox_prefs", fileOpt, options);
	}

};
